import check_circle from './svg/check_circle.svg';
import circle_fill from './svg/circle_fill.svg';
import circle_outline from './svg/circle_outline.svg';
import diamond_fill from './svg/diamond_fill.svg';
import diamond_outline from './svg/diamond_outline.svg';
import error from './svg/error.svg';
import hexagon_fill from './svg/hexagon_fill.svg';
import hexagon_outline from './svg/hexagon_outline.svg';
import info_circle from './svg/info_circle.svg';
import bulb from './svg/lightbulb.svg';
import square_fill from './svg/square_fill.svg';
import square_outline from './svg/square_outline.svg';
import triangle_down_fill from './svg/triangle_down_fill.svg';
import triangle_down_outline from './svg/triangle_down_outline.svg';
import triangle_up_fill from './svg/triangle_up_fill.svg';
import triangle_up_outline from './svg/triangle_up_outline.svg';
import warning from './svg/warning.svg';

const svgs = {
  bulb,
  check_circle,
  circle: circle_fill,
  circle_2: circle_outline,
  circle_fill,
  circle_outline,
  diamond_fill,
  diamond_outline,
  error,
  hexagon: hexagon_fill,
  hexagon_2: hexagon_outline,
  hexagon_fill,
  hexagon_outline,
  info_circle,
  square: square_fill,
  square_2: square_outline,
  square_3: diamond_fill,
  square_4: diamond_outline,
  square_fill,
  square_outline,
  triangle: triangle_up_fill,
  triangle_2: triangle_up_outline,
  triangle_3: triangle_down_fill,
  triangle_4: triangle_down_outline,
  triangle_down_fill,
  triangle_down_outline,
  triangle_up_fill,
  triangle_up_outline,
  warning,
};

export type SvgStatusList = keyof typeof svgs;
export default svgs;
